import undoRedoHistory from "./undoRedoHistory";
import _ from 'lodash';

const undoRedoPlugin = (store) => {
    // initialize and save the starting stage
    undoRedoHistory.init(store);
    let firstState = _.cloneDeep(store.state);
    undoRedoHistory.addState(firstState);

    store.subscribe((mutation, state) => {
        // is called AFTER every mutation
        let after = _.cloneDeep(state);
        undoRedoHistory.addState(after);
    });
};

export default undoRedoPlugin;


// WEBPACK FOOTER //
// ./demo/store/plugins/undoRedoPlugin.js